// extracted by mini-css-extract-plugin
module.exports = {"collapse":"styles_collapse__GsH2u","collapsedRow":"styles_collapsedRow__VLGji","a":"styles_a__9mCwV"};